import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtlasModule } from '@galaxy/atlas';
import { TranslateModule } from '@ngx-translate/core';
import { BusinessNavModule } from '@vendasta/business-nav';
import { AtlasComponent } from './atlas.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    AtlasModule,
    BusinessNavModule.forRoot({
      locationSwitchConfig: {
        supportedLocationContextConfig: [
          {
            context: 'location',
            locationParamKey: 'accountId',
          },
        ],
        defaultPath: 'entry/id_placeholder',
        blockListedPaths: [],
      },
    }),
  ],
  declarations: [AtlasComponent],
  exports: [AtlasComponent],
  providers: [],
})
export class AppAtlasModule {}
